import React from "react";

const ClearFiltersIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      id="Layer_1"
      data-name="Layer 1"
      height="15"
      width="15"
      viewBox="0 0 24 24"
      fill="#f1f2f9"
    >
      <path d="m17.5,0c-3.584,0-6.5,2.916-6.5,6.5s2.916,6.5,6.5,6.5,6.5-2.916,6.5-6.5S21.084,0,17.5,0Zm0,12c-3.033,0-5.5-2.467-5.5-5.5s2.467-5.5,5.5-5.5,5.5,2.467,5.5,5.5-2.467,5.5-5.5,5.5Zm2.854-7.646l-2.146,2.146,2.146,2.146c.195.195.195.512,0,.707-.098.098-.226.146-.354.146s-.256-.049-.354-.146l-2.146-2.146-2.146,2.146c-.098.098-.226.146-.354.146s-.256-.049-.354-.146c-.195-.195-.195-.512,0-.707l2.146-2.146-2.146-2.146c-.195-.195-.195-.512,0-.707s.512-.195.707,0l2.146,2.146,2.146-2.146c.195-.195.512-.195.707,0s.195.512,0,.707Zm-6.354,10.146v9c0,.183-.1.351-.259.438-.075.041-.158.062-.241.062-.093,0-.187-.026-.269-.078l-5-3.183c-.144-.092-.231-.251-.231-.422v-6.136L.852,5.834c-.549-.643-.852-1.468-.852-2.324C0,1.575,1.524,0,3.398,0h8.102c.276,0,.5.224.5.5s-.224.5-.5.5H3.398c-1.322,0-2.398,1.126-2.398,2.51,0,.618.217,1.213.612,1.674l7.268,8.488c.078.091.12.206.12.325v6.046l4,2.546v-8.089c0-.276.224-.5.5-.5s.5.224.5.5Z" />
    </svg>
  );
};

export default React.memo(ClearFiltersIcon);
